// extracted by mini-css-extract-plugin
export default {"maindiv":"ServicePackage_maindiv__5rgf2","firstdiv":"ServicePackage_firstdiv__v2n2n","rightdiv":"ServicePackage_rightdiv__aoDE3","leftdiv":"ServicePackage_leftdiv__0h3w3"};